module.exports = __webpack_public_path__ + "media/images/area/area_tokushimaM400-4c360585ccfa093fc01432efca1e28b6.jpg";